import React, { useState } from "react";
import { Modal, Button, Input, Form, Rate, message, Radio, Space } from "antd";
import "./audienceFeedback.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { submitFeedback } from "../../services/event/feedback-event";
import axios from "axios";
import InteractiveSurveyQuestion, { staticQuestions } from "./InteractiveSurveyQuestion";

const AudienceFeedback: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { eventId } = useParams();
  const { state } = useLocation();
  const { email, jobTitle, userName } = state || {};


  const handleCancel = () => {
    setIsModalVisible(false);
    navigate(`/login/attendee/${eventId}`);
    form.resetFields();
  };

  const handleSubmit = async (values: any) => {
    const feedbackData = {
      eventId: Number(eventId),
      audioVideoQuality: values.audioVideoQuality,
      easeOfUse: values.easeOfUse,
      contentRelevance: values.contentRelevance,
      presenterEffectiveness: values.presenterEffectiveness,
      additionalComments: values.feedback,
      userEmail: values.email,
      jobTitle: values.jobTitle,
      ratingsCount: values.ratingsCount,
    };

    try {
      const response = await submitFeedback(feedbackData);
      
      let formattedAnswers: any[] = [];
      if (values.interactive) {
        formattedAnswers = staticQuestions.map((q, index) => {
          let answerValue = values.interactive[index];
          if (answerValue === undefined || answerValue === null) {
            answerValue = [];
          } else if (!Array.isArray(answerValue)) {
            answerValue = [String(answerValue)];
          } else {
            answerValue = answerValue.map(String);
          }
          return {
            questionText: q.questionText,
            answerValue: answerValue
          };
        });
      } else {
         formattedAnswers = staticQuestions.map((q) => ({
           questionText: q.questionText,
           answerValue: []
         }));
      }

      const apiUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:3000/dev';
      try {
        await axios.post(`${apiUrl}/v1/interactive-forms/responses`, {
           eventId,
           formId: 'unknown',
           userEmail: values.email || email,
           userName: userName || '',
           formTitle: 'Audience Feedback',
           answers: formattedAnswers
        });
      } catch (err) {
        console.error("Failed to submit interactive form responses", err);
      }

      if (response.status === 201 ) {
        message.success("Feedback Submitted Successfully");
        form.resetFields();
        setIsModalVisible(false);
        navigate(`/login/attendee/${eventId}`);
      } else {
        message.error(`Error: ${response.data}`);
      }
    } catch (error) {
      message.error("Something went wrong while submitting feedback.");
    }
  };

  return (
    <div className="feedback-container">
      <Modal
        title="Audience Feedback"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Email"
            name="email"
            initialValue={email}
          >
            <Input value={email} disabled />
          </Form.Item>
          <Form.Item
            label="Job Title"
            name="jobTitle"
            initialValue={jobTitle}
          >
            <Input value={jobTitle} disabled />
          </Form.Item>

          <InteractiveSurveyQuestion />

          <Form.Item
            label="Feedback"
            name="feedback"
            rules={[{ required: true, message: "Please provide feedback!" }]}
          >
            <Input.TextArea placeholder="Enter your feedback" rows={4} />
          </Form.Item>

          <div className="rating-section">
            <Form.Item
              label="Audio/Video Quality"
              name="audioVideoQuality"
              rules={[
                {
                  required: true,
                  message: "Please rate the audio/video quality!",
                },
              ]}
            >
              <Rate />
            </Form.Item>

            <Form.Item
              label="Ease of Use"
              name="easeOfUse"
              rules={[
                { required: true, message: "Please rate the ease of use!" },
              ]}
            >
              <Rate />
            </Form.Item>

            <Form.Item
              label="Content Relevance"
              name="contentRelevance"
              rules={[
                {
                  required: true,
                  message: "Please rate the content relevance!",
                },
              ]}
            >
              <Rate />
            </Form.Item>
            <Form.Item
              label="Presenter Effectiveness"
              name="presenterEffectiveness"
              rules={[
                {
                  required: true,
                  message: "Please rate the presenter's effectiveness!",
                },
              ]}
            >
              <Rate />
            </Form.Item>
          </div>
          <Form.Item className="feedback-buttons">
            <Button onClick={handleCancel} className="btn-cancel-wrapper">Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AudienceFeedback;
